export const RecipeFields = {
  title: 'title',
  ingredients: 'ingredients',
  timeToPrepare: 'timeToPrepare',
  directions: 'directions',
  additionalData: 'additionalData',
};

export const AdditionalDataFields = {
  description: 'description',
  servings: 'servings',
  nutricionalData: 'nutricionalData',
  coverPhotoURL: 'coverPhotoURL',
};

export const NutricionalDataFields = {
  protein: 'protein',
  carbohydrate: 'carbohydrate',
  fat: 'fat',
  calories: 'calories',
};
export const NutricionalDataKeys = Object.keys(NutricionalDataFields);
